import { Card } from "@blueprintjs/core";

import { PropertyType } from "core/decorators/PropertyType";
import { AbstractPropertyType } from "core/util/property/AbstractPropertyType";
import IPropertyRecord from "core/util/property/IPropertyRecord";
import JsonEditor from "../../core/components/editor/JsonEditor";

type V = any;

@PropertyType({name: "literal", label: "Literal"})
export default class LiteralPropertyType extends AbstractPropertyType<V, V> {

	public getDefaultValue() {
		return null;
	}

	public getValue(layout: V): V {
		return layout;
	}

	public getInput(value: V, onChange: (value: V) => void,  wrapper?: IPropertyRecord<V>) {
		return (
			<JsonEditor data={value} onSave={onChange} />
		);
	}

	public getPreviewElement(value: V, minimal: boolean, wrapper: IPropertyRecord<V>) {
		return (
			<Card style={{padding: "5px"}}>
				<b>literal</b>
				<div className="bp3-code-block">
					{JSON.stringify(value)}
				</div>
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/theme/LiteralProperty.type.tsx